/* global Algo */
const Draw = {}

Draw.COLORS0 = ['LightBlue', 'Pink', 'Wheat', 'PaleGreen', 'Gold', 'IndianRed', 'DarkCyan', 'Plum', 'SeaGreen', 'Fuchsia', 'PaleVioletRed']
Draw.COLORS1 = ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffaa', '#e5d8bd', '#fddaec', '#f2f2f2']
Draw.COLORS2 = ['#ff00ff', '#0000ff', '#00ffff', '#ffff00', '#ff0000', '#a67e52', '#e9ed96']
Draw.COLORS4 = [
  // red Lime Blue Yellow
  // Magenta Orange Cyan DeepSkyBlue
  // DarkViolet Khaki
  '#FF0000', '#00FF00', '#0000FF', '#FFFF00',
  '#FF00FF', '#FFA500', '#00FFFF', '#00BFFF',
  '#9400D3', '#F0E68C',
]
Draw.COLORS32 = [
  'crimson', 'limegreen', 'dodgerblue', 'darkturquoise', 'blueviolet', 'gold',
  'orangered', 'yellowgreen', 'lightskyblue', 'palegreen', 'lightpink', 'darkorange',
  'saddlebrown', 'olive', 'slateblue', 'darkslategray', 'purple', 'tan',
  'red', 'lawngreen', 'blue', 'cyan', 'magenta', 'yellow',
  'brown', 'green', 'navy', 'teal', 'indigo', 'khaki',
  'lightsteelblue', 'steelblue',
]

function isObject(x) {
  return x && typeof (x)==='object'
} // isObject

function defined(x) {
  return x!==undefined && x!==null
} // defined

function positive(x) {
  return parseInt(x)>0
} // positive

function natural(x) {
  return parseInt(x)>=0
} // natural

Draw.loadFont = async function(font_name, font_data) {
  if(!font_data) return
  let type = 'font/ttf'
  if(typeof font_data==='string') {
    // font_data is URL
    type = 'font/' + font_data.replace(/.*\.(\w+)$/, '$1')
    const res = await fetch(font_data)
    if(!res.ok) {
      return
    }
    font_data = await res.arrayBuffer()
  }

  const blob = new Blob([font_data], { type })
  const url = URL.createObjectURL(blob)

  const font = new FontFace(font_name, `url(${url})`)
  await font.load()

  document.fonts.add(font)
  await document.fonts.ready
  URL.revokeObjectURL(url)
  return font
} // loadFont

Draw.find = function(path) {
  return document.getElementById(path) || document.body.querySelector(path)
} // find

Draw.getContext = function(src, alpha) {
  if(src instanceof HTMLCanvasElement) {
    const ctx = src.getContext('2d', { alpha: !!alpha, willReadFrequently: true })
    return [ctx, src, src.width, src.height, src.width*src.height]
  }else if(src instanceof CanvasRenderingContext2D) {
    const canvas = src.canvas
    return [src, canvas, canvas.width, canvas.height, canvas.width*canvas.height]
  }else{
    return []
  }
} // getContext

Draw.canvasToJpegUint8Array = async function(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      const reader = new FileReader()
      reader.onloadend = function() {
        const arrayBuffer = reader.result
        const uint8Array = new Uint8Array(arrayBuffer)
        resolve(uint8Array)
      }
      reader.onerror = function() {
        reject(new Error('Failed to read the blob'))
      }
      reader.readAsArrayBuffer(blob)
    }, 'image/jpeg')
  })
} // canvasToJpegUint8Array

Draw.jpegUint8ArrayToImg = async function(jpeg, img) {
  const blob = new Blob([jpeg], { type: 'image/jpeg' })
  const url = URL.createObjectURL(blob)
  img = img || new Image()
  try {
    await new Promise((resolve, reject) => {
      img.onload = () => resolve(img)
      img.onerror = () => reject(new Error('Failed to load image'))
      img.src = url
    })
  }catch(e) {
    img = null
    console.error(e)
  }
  URL.revokeObjectURL(url)
  return img
} // jpegUint8ArrayToImg

Draw.jpegUint8ArrayToCanvas = async function(canvas, jpeg, filter) {
  const blob = new Blob([jpeg], { type: 'image/jpeg' })
  const url = URL.createObjectURL(blob)
  if(!canvas) canvas = document.createElement('canvas')
  try {
    const img = await new Promise((resolve, reject) => {
      const img = new Image()
      img.onload = () => resolve(img)
      img.onerror = () => reject(new Error('Failed to load image'))
      img.src = url
    })

    const ctx = canvas.getContext('2d')
    canvas.width = img.width
    canvas.height = img.height
    if(filter) ctx.filter = filter
    ctx.drawImage(img, 0, 0)
  }catch(e) {
    canvas = null
    console.error(e)
  }
  URL.revokeObjectURL(url)
  return canvas
} // jpegUint8ArrayToCanvas

Draw.jpegUint8ArrayToDataURL = async function(jpeg_uint) {
  if(!jpeg_uint || jpeg_uint.length===0) return
  return new Promise((resolve) => {
    const blob = new Blob([jpeg_uint], { type: 'image/jpeg' })
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = () => resolve('')
    reader.readAsDataURL(blob)
  })
} // jpegUint8ArrayToDataURL

Draw.imgFromUint8Array = async function(uint, type='image/jpeg') {
  if(!uint || uint.length===0) return
  const blob = new Blob([uint], { type })
  if(!blob) return
  const url = URL.createObjectURL(blob)
  if(!url) return
  const img = await new Promise((resolve) => {
    const img = new Image()
    img.onload = ()=>resolve(img)
    img.onerror = ()=>resolve()
    img.src = url
  })
  URL.revokeObjectURL(url)
  return img
} // imgFromUint8Array

Draw.imgFromSrc = async function(src) {
  const img = await new Promise((resolve) => {
    const img = new Image()
    img.onload = ()=>resolve(img)
    img.onerror = ()=>resolve()
    img.src = src
  })
  return img
} // imgFromSrc

Draw.imgFromCanvas = async function(canvas, type='image/jpeg') {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = ()=>resolve(img)
    img.onerror = ()=>resolve()
    img.src = canvas.toDataURL(type)
  })
} // imgFromCanvas

Draw.cropImageDataURL = async function(img_datauri, cropX, cropY, cropWidth, cropHeight) {
  return new Promise((resolve) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => {
      const canvas = document.getElementById('canvas')
      canvas.width = cropWidth
      canvas.height = cropHeight
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight)
      resolve(canvas.toDataURL('image/jpeg'))
    }
    img.src = img_datauri
    img.onerror = () => resolve('')
  })
} // cropImageDataURL

Draw.getImageData = function(src) {
  if(src instanceof ImageData) {
    return src
  }else if(src instanceof HTMLCanvasElement) {
    const ctx = src.getContext('2d', { alpha: true, willReadFrequently: true })
    return ctx.getImageData(0, 0, src.width, src.height)
  }else if(src instanceof CanvasRenderingContext2D) {
    return src.getImageData(0, 0, src.canvas.width, src.canvas.height)
  }else{
    return {}
  }
} // getImageData

Draw.putImageData = function(dst, src) {
  dst = Draw.getContext(dst)[0]
  src = Draw.getImageData(src)
  dst.putImageData(src, 0, 0)
} // getImageData

Draw.clear = function(sources) {
  sources = Array.isArray(sources) ? sources : [sources]
  for(const src of sources) {
    const [ctx, , width, height] = Draw.getContext(src, true)
    ctx.clearRect(0, 0, width, height)
  }
} // clear

Draw.drawPoints = function(sources, points, color, size=1) {
  sources = Array.isArray(sources) ? sources : [sources]
  const minus = Math.floor((size-1)/2)
  for(const src of sources) {
    const [ctx] = Draw.getContext(src)
    ctx.fillStyle = color
    for(const [x, y] of points) ctx.fillRect(x-minus, y-minus, size, size)
  }
} // drawPoints

Draw.drawLine = function(sources, x1, y1, x2, y2, color, linewidth=1) {
  sources = Array.isArray(sources) ? sources : [sources]
  for(const src of sources) {
    const [ctx, canvas, width, height] = Draw.getContext(src)

    if(isObject(x1)) {
      color = y1
      linewidth = x2 || 1
      const line = x1
      if(defined(line.x1)) {
        x1 = line.x1
        y1 = line.y1
        x2 = line.x2
        y2 = line.y2
      }else if(defined(line.theta) && typeof Algo==='object') {
        ({ x1, y1, x2, y2 } = Algo.houghToEuclid(line.r, line.theta, 0, width, 0, height))
      }else {
        return
      }
    }

    let _linewidth = linewidth
    if(linewidth<0) {
      // negative thickness indicate adjust thickness bsed on canvas displayed size
      const rect = canvas.getBoundingClientRect()
      _linewidth = -linewidth * canvas.width / rect.width
    }

    ctx.beginPath()
    ctx.moveTo(x1, y1)
    ctx.lineTo(x2, y2)
    ctx.strokeStyle = color
    ctx.lineWidth = _linewidth
    ctx.stroke()
  }
} // drawLine

Draw.drawLines = function(sources, lines, color, linewidth) {
  for(const line of lines) { Draw.drawLine(sources, line, color, linewidth) }
} // drawLines

Draw.drawPolyline = function(sources, points, color='#000000', linewidth=1) {
  if(!Array.isArray(points) || points.length<1) return
  sources = Array.isArray(sources) ? sources : [sources]
  for(const src of sources) {
    const [ctx, canvas] = Draw.getContext(src)

    // draw line between points
    ctx.beginPath()
    ctx.strokeStyle = color
    let _linewidth = linewidth
    if(linewidth<0) {
      // negative thickness indicate adjust thickness bsed on canvas displayed size
      const rect = canvas.getBoundingClientRect()
      _linewidth = -linewidth * canvas.width / rect.width
    }
    ctx.lineWidth = _linewidth
    ctx.moveTo(...points[0])
    for(let i=1; i<points.length; i++) {
      ctx.lineTo(...points[i])
    }
    ctx.stroke()
  }
} // drawPolyline

Draw.drawRectangle = function(sources, x1, y1, width, height, bg, color, linewidth=1) {
  sources = Array.isArray(sources) ? sources : [sources]
  if(isObject(x1)) {
    linewidth = height || 1
    color = width
    bg = y1
    const def = x1
    x1 = def.x1 ?? def.x
    y1 = def.y1 ?? def.y
    width = def.width ?? (def.x2 - x1 + 1)
    height = def.height ?? (def.y2 - y1 + 1)
  }
  for(const src of sources) {
    const [ctx, canvas] = Draw.getContext(src)
    ctx.beginPath()
    if(defined(color)) {
      ctx.strokeStyle = color
      let _linewidth = linewidth
      if(linewidth<0) {
        // negative thickness indicate adjust thickness bsed on canvas displayed size
        const rect = canvas.getBoundingClientRect()
        _linewidth = -linewidth * canvas.width / rect.width
      }
      ctx.lineWidth = _linewidth
    }
    if(defined(bg)) {
      ctx.fillStyle = bg
    }
    ctx.moveTo(x1, y1)
    ctx.lineTo(x1+width, y1)
    ctx.lineTo(x1+width, y1+height)
    ctx.lineTo(x1, y1+height)
    ctx.closePath()
    if(defined(color)) ctx.stroke()
    if(defined(bg)) ctx.fill()
  }
} // drawRectangle

Draw.drawCorners = function(sources, x1, y1, width, height, size, color, linewidth=1, exclusion) {
  sources = Array.isArray(sources) ? sources : [sources]
  if(isObject(x1)) {
    let x2
    let y2
    exclusion = size
    linewidth = height || 1
    color = width
    size = y1
    ;({ x1, y1, x2, y2, width, height } = x1)
    if(isNaN(width) && x2>=x1) width = x2-x1+1
    if(isNaN(height) && y2>=y1) height = y2-y1+1
  }

  const x2 = x1 + width - 1
  const y2 = y1 + height - 1

  if(typeof exclusion!=='function') exclusion = ()=>false

  const drawn = {}
  for(const src of sources) {
    const [ctx, canvas] = Draw.getContext(src)
    if(defined(color)) {
      ctx.strokeStyle = color
      let _linewidth = linewidth
      if(linewidth<0) {
        // negative thickness indicate adjust thickness bsed on canvas displayed size
        const rect = canvas.getBoundingClientRect()
        _linewidth = -linewidth * canvas.width / rect.width
      }
      ctx.lineWidth = _linewidth
    }

    ctx.beginPath()

    if(!exclusion(x1, y1)) {
      ctx.moveTo(x1, y1)
      ctx.lineTo(x1+size, y1)
      ctx.moveTo(x1, y1)
      ctx.lineTo(x1, y1+size)
      drawn.tl = 1
    }

    if(!exclusion(x2, y1)) {
      ctx.moveTo(x2, y1)
      ctx.lineTo(x2-size, y1)
      ctx.moveTo(x2, y1)
      ctx.lineTo(x2, y1+size)
      drawn.tr = 1
    }

    if(!exclusion(x2, y2)) {
      ctx.moveTo(x2, y2)
      ctx.lineTo(x2-size, y2)
      ctx.moveTo(x2, y2)
      ctx.lineTo(x2, y2-size)
      drawn.br = 1
    }

    if(!exclusion(x1, y2)) {
      ctx.moveTo(x1, y2)
      ctx.lineTo(x1+size, y2)
      ctx.moveTo(x1, y2)
      ctx.lineTo(x1, y2-size)
      drawn.bl = 1
    }

    ctx.stroke()
  }

  if(drawn.tl && drawn.tr) drawn.t = 1
  if(drawn.bl && drawn.br) drawn.b = 1
  if(drawn.tl && drawn.bl) drawn.l = 1
  if(drawn.tr && drawn.br) drawn.r = 1
  if(drawn.t && drawn.b) drawn.all = 1
  return drawn
} // drawCorners

Draw.drawPolygon = function(sources, polygon, bg, color, linewidth=1) {
  sources = Array.isArray(sources) ? sources : [sources]
  for(const src of sources) {
    const [ctx, canvas] = Draw.getContext(src)
    ctx.beginPath()
    if(defined(color)) {
      ctx.strokeStyle = color
      let _linewidth = linewidth
      if(linewidth<0) {
        // negative thickness indicate adjust thickness bsed on canvas displayed size
        const rect = canvas.getBoundingClientRect()
        _linewidth = -linewidth * canvas.width / rect.width
      }
      ctx.lineWidth = _linewidth
    }
    if(defined(bg)) {
      ctx.fillStyle = bg
    }
    ctx.moveTo(polygon[0][0], polygon[0][1])
    for(let i=1; i<polygon.length; i++) { ctx.lineTo(polygon[i][0], polygon[i][1]) }
    ctx.closePath()
    if(defined(color)) ctx.stroke()
    if(defined(bg)) ctx.fill()
  }
} // drawPolygon

Draw.drawPolygons = function(sources, polygons, bg, color, linewidth) {
  for(const polygon of polygons) { Draw.drawPolygon(sources, polygon, bg, color, linewidth) }
} // drawPolygons

Draw.drawCross = function(sources, x, y, size, color, linewidth=1) {
  sources = Array.isArray(sources) ? sources : [sources]
  for(const src of sources) {
    const [ctx, canvas] = Draw.getContext(src)
    let _linewidth = linewidth
    let rect
    if(linewidth<0) {
      // negative thickness indicate adjust thickness bsed on canvas displayed size
      rect = canvas.getBoundingClientRect()
      _linewidth = -linewidth * canvas.width / rect.width
    }
    let _size = size
    if(size<0) {
      if(!rect) rect = canvas.getBoundingClientRect()
      _size = -size * canvas.width / rect.width
    }
    ctx.beginPath()
    ctx.moveTo(x-_size, y)
    ctx.lineTo(x+_size, y)
    ctx.moveTo(x, y-_size)
    ctx.lineTo(x, y+_size)
    ctx.strokeStyle = color
    ctx.lineWidth = _linewidth
    ctx.stroke()
  }
} // drawCross

Draw.drawCircle = function(sources, x, y, r, bg, color, linewidth) {
  sources = Array.isArray(sources) ? sources : [sources]
  for(const src of sources) {
    const [ctx] = Draw.getContext(src)
    ctx.beginPath()
    ctx.arc(x, y, r, 0, 2 * Math.PI, false)
    if(bg) {
      ctx.fillStyle = bg
      ctx.fill()
    }
    if(color) {
      ctx.strokeStyle = color
      ctx.lineWidth = linewidth || 1
      ctx.stroke()
    }
  }
} // drawCircle

Draw.drawEllipse = function(sources, x, y, a, b, bg, color, linewidth) {
  sources = Array.isArray(sources) ? sources : [sources]
  for(const src of sources) {
    const [ctx] = Draw.getContext(src)
    ctx.beginPath()
    if(ctx.ellipse) {
      ctx.ellipse(x, y, a, b, 0, 0, 2 * Math.PI)
    }else {
      b *= src.canvas.width/src.canvas.height
      ctx.moveTo(x + a, y)
      ctx.bezierCurveTo(x+a, y-b, x-a, y-b, x-a, y)
      ctx.bezierCurveTo(x-a, y+b, x+a, y+b, x+a, y)
    }
    if(bg) {
      ctx.fillStyle = bg
      ctx.fill()
    }
    if(color) {
      ctx.strokeStyle = color
      ctx.lineWidth = linewidth || 1
      ctx.stroke()
    }
  }
} // drawCircle

Draw.drawText = function(sources, text, size, x, y, align, fill, stroke, linewidth=1, font='Helvetica') {
  const arr = Array.isArray(sources)
  sources = arr ? sources : [sources]
  const measures = []
  for(const src of sources) {
    const [ctx] = Draw.getContext(src)

    ctx.font = size+'px '+font
    ctx.textAlign = align || 'center'
    ctx.textBaseline = 'middle'

    if(fill) {
      ctx.fillStyle = fill === -1 ? 'black' : fill
      if(fill !== -1) ctx.fillText(text, x, y)
    }
    if(stroke) {
      ctx.strokeStyle = stroke === -1 ? 'white' : stroke
      ctx.lineWidth = linewidth
      if(stroke !== -1) ctx.strokeText(text, x, y)
    }
    const measure = ctx.measureText(text)
    measure.height = measure.fontBoundingBoxAscent - measure.ideographicBaseline
    measures.push(measure)
  }
  if(arr) {
    return measures
  }else {
    return measures[0]
  }
} // drawText

Draw.measureText = function(sources, text, size, x, y, align, fill, stroke, linewidth=1, font='Helvetica') {
  fill = fill ? -1 : null
  stroke = stroke ? -1 : null
  return Draw.drawText(sources, text, size, x, y, align, fill, stroke, linewidth, font)
} // measureText

Draw.fillCanvas = function(sources, color='#fff') {
  sources = Array.isArray(sources) ? sources : [sources]
  for(const src of sources) {
    const [ctx,, width, height] = Draw.getContext(src)
    ctx.fillStyle = color
    ctx.fillRect(0, 0, width, height)
  }
} // fillCanvas

Draw.canvas2rgba = function(src) {
  const { data, width, height } = Draw.getImageData(src)
  if(!data) return
  data.width = width
  data.height = height
  data.kind = 'rgba'
  return data
} // canvas2rgba

Draw.canvas2rgb = function(src) {
  const { data, width, height } = Draw.getImageData(src)
  if(!data) return
  const size = width*height
  const dst = new Uint8Array(size*3)
  const size4 = size*4
  for(let i=0, j=0; i<size4; i+=4, j+=3) {
    dst[j] = data[i]
    dst[j+1] = data[i+1]
    dst[j+2] = data[i+2]
  }
  dst.width = width
  dst.height = height
  data.kind = 'rgb'
  return dst
} // canvas2rgb

Draw.rgba2canvas = function(src, dst) {
  if(!(src instanceof Uint8Array || src instanceof Uint8ClampedArray) || !src.width || !src.height) return
  const { width, height } = src

  let [ctx, canvas] = Draw.getContext(dst)
  if(!ctx) return
  if(canvas.width !== width || canvas.height !== height) {
    canvas.width = width
    canvas.height = height
    ctx = Draw.getContext(canvas)[0]
  }

  const imageData = new ImageData(new Uint8ClampedArray(src), width, height)
  ctx.putImageData(imageData, 0, 0)
  return canvas
} // rgb2canvas

Draw.rgb2canvas = function(src, dst) {
  if(!(src instanceof Uint8Array || src instanceof Uint8ClampedArray) || !src.width || !src.height) return
  const width = parseInt(src.width)
  const height = parseInt(src.height)

  let [ctx, canvas] = Draw.getContext(dst)
  if(canvas) dst = ctx.createImageData(width, height)
  if(!(dst instanceof ImageData)) return
  if(canvas.width !== width || canvas.height !== height) {
    canvas.width = width
    canvas.height = height
    ctx = Draw.getContext(canvas)[0]
  }

  const data = dst.data
  const size3 = width*height*3
  for(let i=0, j=0; i<size3; i+=3, j+=4) {
    data[j] = src[i]
    data[j+1] = src[i+1]
    data[j+2] = src[i+2]
    data[j+3] = 255
  }
  if(ctx) ctx.putImageData(dst, 0, 0)
  return dst
} // rgb2canvas

Draw.canvas2gray = function(src) {
  const { data, width, height } = Draw.getImageData(src)
  if(!data) return
  const size = width*height
  const dst = new Uint8Array(size)
  const size4 = size*4
  for(let i=0, j=0; i<size4; i+=4, j++) {
    dst[j] = (data[i]*3 + data[i+1]*4 + data[i+2]) >> 3
  }
  dst.width = width
  dst.height = height
  return dst
} // canvas2gray

Draw.gray2canvas = function(src, dst) {
  if(!(src instanceof Uint8Array || src instanceof Uint8ClampedArray) || !src.width || !src.height) return
  const width = parseInt(src.width)
  const height = parseInt(src.height)

  let [ctx, canvas] = Draw.getContext(dst)
  if(canvas) dst = ctx.createImageData(width, height)
  if(!(dst instanceof ImageData)) return
  if(canvas.width !== width || canvas.height !== height) {
    canvas.width = width
    canvas.height = height
    ctx = Draw.getContext(canvas)[0]
  }

  const data = dst.data
  const size = width*height
  for(let i=0, j=0; i<size; i++, j+=4) {
    data[j] = data[j+1] = data[j+2] = src[i]
    data[j+3] = 255
  }
  if(ctx) ctx.putImageData(dst, 0, 0)
  return dst
} // gray2canvas

Draw.createCanvas = function(parent, src, id, className) {
  const el = document.createElement('canvas')
  if(isObject(src)) {
    el.width = src.videoWidth || src.width
    el.height = src.videoHeight || src.height
  }
  if(defined(id)) el.id = id
  if(defined(className)) el.className = className
  if(isObject(parent)) parent.appendChild(el)
  return el
} // createCanvas

Draw.drawGrid = function(dst, horizontal, vertical, all_color='rgba(0,0,255,0.2)') {
  const { width, height } = dst
  if(isObject(horizontal)) {
    const { major=100, minor=10, color=all_color } = horizontal
    const mid = height/2
    for(let i=0; i<mid; i+=minor) {
      const stroke = i%major===0 ? 2 : 1
      Draw.drawLine(dst, 0, mid-i, width, mid-i, color, stroke)
      Draw.drawLine(dst, 0, mid+i, width, mid+i, color, stroke)
    }
  }
  if(isObject(vertical)) {
    const { major=100, minor=10, color=all_color } = vertical
    const mid = width/2
    for(let i=0; i<mid; i+=minor) {
      const stroke = i%major===0 ? 2 : 1
      Draw.drawLine(dst, mid-i, 0, mid-i, height, color, stroke)
      Draw.drawLine(dst, mid+i, 0, mid+i, height, color, stroke)
    }
  }
} // drawGrid

Draw.drawHistogram = function(dst, histogram, h_width, h_height, h_left, h_top, bg='rgba(255,255,255,0.2)', color='rgba(255,0,0,0.4)', ephasize_color) {
  const emphasize = Array.isArray(histogram.emphasize) && histogram.emphasize.length>0 ? histogram.emphasize : null
  const [ctx, width, height] = Draw.getContext(dst)
  if(!positive(h_width)) h_width = width
  if(!positive(h_height)) h_height = height
  if(!natural(h_left)) h_left = 0
  if(!natural(h_top)) h_top = 0
  const max_hist = Math.max(...histogram)
  const count_hist = histogram.length
  const h_offset = h_width/20
  const dx = (h_width-h_offset*2)/count_hist
  const dy = h_height / max_hist
  ctx.fillStyle = bg
  ctx.fillRect(h_left, h_top, h_width, h_height)
  ctx.fillStyle = color
  for(let i=0; i<count_hist; i++) {
    const x = h_left + h_offset + dx*i
    const h = dy*histogram[i]
    const y = h_top + h_height-h
    const w = dx
    if(emphasize && emphasize.indexOf(i)>=0) {
      ctx.fillStyle = ephasize_color || 'red'
      ctx.fillRect(x, y, w, h)
      ctx.fillStyle = color
    }else{
      ctx.fillRect(x, y, w, h)
    }
  }
} // drawHistogram

Draw.drawRotated = function(dst, src, degree) {
  const [ctx,, width, height] = Draw.getContext(dst)
  ctx.clearRect(0, 0, width, height)
  ctx.translate(width/2, height/2)
  ctx.rotate(degree/180*Math.PI)
  if(src instanceof CanvasRenderingContext2D) src = src.canvas
  ctx.drawImage(src, 0, 0, src.width, src.height, -width/2, -height/2, src.width, src.height)
  ctx.setTransform(1, 0, 0, 1, 0, 0)
} // drawRotated

Draw.placeOver = function(base, el, z, offset_x=0, offset_y=0) {
  el.style.position = 'absolute'
  const rect = base.getBoundingClientRect()
  const prect = base.parentElement.getBoundingClientRect()
  el.style.zIndex = z
  el.style.objectFit = 'contain'
  const h_scale = rect.width / (base.naturalWidth||base.videoWidth||base.width)
  const v_scale = rect.height / (base.naturalHeight||base.videoHeight||base.height)
  el.style.width = (el.width * h_scale) + 'px'
  el.style.height = (el.height * v_scale) + 'px'
  const left = rect.left - prect.left + window.scrollX + offset_x*h_scale
  const top = rect.top - prect.top + window.scrollY + offset_y*v_scale
  el.style.left = `${left}px`
  el.style.top = `${top}px`

  // el.style.pointerEvents = 'none'
  base.parentElement.append(el)
} // placeOver

// obtain real canvas coordinates from mouse event coordinates on canvas
Draw.canvasXY = function(canvas, clientX, clientY) {
  const { width, height } = canvas
  const rect = canvas.getBoundingClientRect()
  const canvas_aspect = canvas.width / canvas.height
  const rect_aspect = rect.width / rect.height
  let scale, offsetX, offsetY
  if(canvas_aspect > rect_aspect) {
    // Horizontal letterboxing
    scale = rect.width / canvas.width
    offsetX = 0
    offsetY = (rect.height - canvas.height * scale) / 2
  } else {
    // Vertical letterboxing
    scale = rect.height / canvas.height
    offsetX = (rect.width - canvas.width * scale) / 2
    offsetY = 0
  }

  const x = Math.round((clientX - rect.left - offsetX) / scale)
  const y = Math.round((clientY - rect.top - offsetY) / scale)

  const inside = x>=0 && x<width && y>=0 && y<height
  return inside ? { x, y, rect, offsetX, offsetY } : {}
} // canvasXY

Draw.eventXY = function(e) {
  if(e.type.startsWith('touch')) {
    const { clientX, clientY } = e.touches[0] || e.changedTouches[0] || {}
    e.clientX = clientX
    e.clientY = clientY
  }
  const { target, clientX, clientY } = e
  return Draw.canvasXY(target, clientX, clientY)
} // eventXY

if(typeof module!=='undefined') { module.exports = Draw } else if(typeof window!=='undefined') { window.Draw = Draw }
